import * as React from 'react';

import { cva } from 'class-variance-authority';

import { cn } from '@/utils';

const textareaVariants = cva('', {
	variants: {
		size: {
			default: 'h-10 px-3',
			xl: 'h-12 px-3 text-sm lg:h-14 lg:px-4 lg:text-base',
			lg: 'h-10 px-3 py-2.5 text-sm lg:h-12 lg:text-base'
		},
		error: {
			true: 'border-border-red focus:border-border-red'
		}
	},
	defaultVariants: {
		size: 'default'
	}
});

const Textarea = React.forwardRef(
	({ className, size, error, ...props }, ref) => {
		return (
			<textarea
				className={cn(
					'flex w-full rounded border border-grey-300 bg-background px-3 py-2 text-sm transition-colors placeholder:text-grey-500 focus:border-black focus-visible:outline-none disabled:cursor-not-allowed disabled:bg-grey-200 disabled:text-grey-500',
					error && 'border-red focus:border-red',
					className,
					textareaVariants({ size }),
					'h-20 resize-none'
				)}
				ref={ref}
				{...props}
			/>
		);
	}
);
Textarea.displayName = 'Textarea';

export default Textarea;
